import React, { useEffect, useState } from "react";
import { thankyouIcon, thumbUpIcon } from "../assets/images";
import { useParams } from "react-router-dom";
import { GetMemberStatus, checkRejectStatus } from "../api/common";
import { ApplicationStatusSkeleton } from "../Components/ui";
import { Form, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";

export default function ApplicationStatus() {
  const [check, setCheck] = useState(true);
  const [userData, setUserData] = useState({});
  const { user_id, status, num } = useParams();
  const [previousStatus, setPreviousStatus] = useState(0);
  const [loading, setLoading] = useState(true);
  const [showComment, setShowComment] = useState(false);

  const validationSchema = Yup.object().shape({
    comment: Yup.string()
      .required("Comment is required")
      .test(
        "max-words",
        "Comment should be less than 500 words",
        (value) => value && value.trim().split(/\s+/).length <= 500
      ),
  });

  const formik = useFormik({
    initialValues: {
      comment: "",
    },
    validationSchema,
    onSubmit: async (values) => {
      getMemberStatus(values.comment);
    },
  });

  const getMemberStatus = (comment = "") => {
    setCheck(true);
    setLoading(true);
    GetMemberStatus(user_id, status, num, comment)
      .then((res) => {
        if (res.status === 200 && res.data.success) {
          setCheck(true);
          setUserData(res.data.userdata);
          setShowComment(false);
        } else {
          setUserData({});
          setCheck(false);
          setPreviousStatus(res.data.prevoius_status);
        }
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const checkStatus = () => {
    checkRejectStatus(user_id, status, num)
      .then((res) => {
        if (res.status === 200 && res.data.success) {
          setCheck(false);
          setShowComment(false);
        } else if (
          res.status === 200 &&
          !res.data?.success &&
          res.data?.comment
        ) {
          setCheck(false);
          setShowComment(true);
        }
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    if (!status) return;
    if (status === "reject") {
      checkStatus();
    } else getMemberStatus();
  }, []); // eslint-disable-line

  const { values, errors, touched, handleSubmit } = formik;

  return (
    <>
      <div className="referencePage">
        <div className="referenceDetails text-center">
          {check ? (
            <>
              <img src={thankyouIcon} alt="" className="thankyouIcon" />
              {!loading && (
                <h2 style={{ textTransform: "capitalize" }}>
                  Your Reference is{" "}
                  {status === "approve" ? "Approved" : "Rejected"}
                </h2>
              )}
              {loading ? (
                <ApplicationStatusSkeleton />
              ) : (
                <>
                  {Object.keys(userData).length > 0 && (
                    <>
                      <div className="dataRow">
                        <div>
                          Applicant Name <span className="colon">:</span>
                        </div>
                        <div>{userData.name}</div>
                      </div>
                      <div className="dataRow">
                        <div>
                          Applicant Email <span className="colon">:</span>
                        </div>
                        <div>{userData.email}</div>
                      </div>
                      {userData.company_name && (
                        <div className="dataRow">
                          <div>
                            Company Name <span className="colon">:</span>
                          </div>
                          <div>{userData.company_name}</div>
                        </div>
                      )}
                    </>
                  )}
                </>
              )}
            </>
          ) : showComment ? (
            <>
              <FormikProvider value={formik}>
                <Form onSubmit={handleSubmit}>
                  <div className="membershipForm">
                    <div className="form-group">
                      <textarea
                        className="form-control textarea"
                        placeholder="Please Enter Comment"
                        name="comment"
                        value={values.comment}
                        onChange={(e) => {
                          formik.setFieldValue("comment", e.target.value);
                        }}
                      />

                      <div
                        className={
                          "d-flex justify-content-between" +
                          (values.comment.trim().split(/\s+/).length > 500
                            ? " error"
                            : "")
                        }
                      >
                        <span className="input-char-count">
                          {values.comment
                            ? values.comment.trim().split(/\s+/).length
                            : 0}
                          / 500
                        </span>
                        {values.comment.trim().split(/\s+/).length > 500 && (
                          <span className="input-char-count">
                            {values.comment.trim().split(/\s+/).length - 500}{" "}
                            words exceeded
                          </span>
                        )}
                      </div>
                      {touched.comment && errors.comment && (
                        <div className="error">{errors.comment}</div>
                      )}

                      <button
                        disabled={
                          loading || errors.comment || values.comment === ""
                        }
                        className="btn btn-primary"
                        type="submit"
                      >
                        Reject
                      </button>
                    </div>
                  </div>
                </Form>
              </FormikProvider>
            </>
          ) : (
            <>
              <img src={thumbUpIcon} alt="" className="thankyouIcon" />
              <h2>Your Response is Already Recorded</h2>
              <p>
                Your previous response was{" "}
                {previousStatus === 1 ? "Approved" : "Rejected"}
              </p>
            </>
          )}
        </div>
        {showComment ? null : (
          <p className="close-window-text">
            You can{" "}
            <span className="close-window-link" onClick={() => window.close()}>
              close the window
            </span>{" "}
            now
          </p>
        )}
      </div>
    </>
  );
}
